import './Main.css'

import React from 'react'

import { useAppContext } from '@/context/app'
import { Spinner } from '@/components/spinner'
import { Machine } from '@/services/model/machine'
import { useNavigate } from 'react-router-dom'
import { useWizard } from '@/common/wizard/wizard'
import { WizardData } from './Model'


export const Result = ({ machine, goDone }: {
  goDone: (acceptedSteps: string[]) => void
  machine: Machine
}) => {
  const { translates } = useAppContext()
  const navigate = useNavigate()
  const { wizardData } = useWizard<WizardData>()

  if (!translates) {
    return <Spinner />
  }

  return <div>
    <h2>{translates.for('machine.checklist.wizard.result.title')}</h2>
    {translates.for('machine.checklist.wizard.result.description')}
    <div className='btns'>
      <a className='btn btn-next main-btn' onClick={() => goDone(wizardData.acceptedSteps)}>
        {translates.for('machine.checklist.wizard.result.approve')}
      </a>
    </div>
  </div>
}